import { laptopMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';
import { SubHeading } from '../typography';

const FeaturesTrioContainer = styled.section`
  margin-bottom: 78px;
  margin-top: 78px;

  @media screen and (${tabletMax}) {
    margin-top: 52px;
  }

  @media (${mobileXXLargeMax}) {
    margin-bottom: 10px;
  }

  ${SubHeading} {
    font-size: 36px;
    padding: 0 30px;
  }

  @media (${mobileXXLargeMax}) {
    ${SubHeading} {
      margin: 30px auto;
      padding: 0 15px;
      max-width: 500px;
      font-size: 26px;
      line-height: 33px;
      text-align: center;
    }
  }
`;

const FeaturesTrioListContainer = styled.ul`
  margin: 0;
  padding: 0 50px;
  list-style: none;
  display: grid;

  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 2em;

  @media screen and (${laptopMax}) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (${tabletMax}) {
    padding: 0 30px;
    grid-template-columns: 1fr;
  }
`;

const FeaturesElement = styled.li`
  display: flex;
`;

const FeatureContent = styled.div`
  margin-left: 20px;
`;

const FeatureIntroPara = styled.p`
  padding-bottom: 10px;
`;

const FeatureIcon = styled.div`
  min-width: 50px;

  & > svg {
    max-width: 100%;
  }
`;

const FeaturesLink = styled(Link)`
  color: ${(props) => props.theme.primary};
  font-weight: bold;
  display: inline-flex;
  & > svg {
    margin-left: 5px;
    font-size: 25px;
  }

  &:hover {
    color: ${(props) => props.theme.backgroundMid};
  }
`;

export {
  FeaturesTrioContainer,
  FeaturesTrioListContainer,
  FeaturesElement,
  FeatureContent,
  FeatureIntroPara,
  FeatureIcon,
  FeaturesLink,
};
